import script from "./ShisetsuMessageModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ShisetsuMessageModal.vue?vue&type=script&setup=true&lang=js"

import "./ShisetsuMessageModal.vue?vue&type=style&index=0&id=4c57de4e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c57de4e"]])

export default __exports__